import {
    createReportBlogArticleClicked,
    createReportFAQClicked,
    createReportGetStartedSubmitted,
} from '../../../../shared/mixpanel/events';
import store from '../store';
import { reportPageView } from './reportPageView';

const reportBlogArticleClicked = createReportBlogArticleClicked(store);
const reportFAQClicked = createReportFAQClicked(store);
const reportGetStartedSubmitted = createReportGetStartedSubmitted(store);

export {
    reportPageView,
    reportBlogArticleClicked,
    reportFAQClicked,
    reportGetStartedSubmitted,
};
